import React from 'react';
import {Paper, Typography} from "@mui/material";


import ProcurementContainer from '../../procurement/containers/ProcurementContainer';

import InventoryLocationList from '../lists/inventoryLocationList';
import CreateInventoryLocationComponent from '../component/CreateInventoryLocationComponent';



const InventoryLocationPage: React.FC = () => {
  return (
    <ProcurementContainer>
      <Typography variant='h1' gutterBottom style={{ fontWeight: 'bold', color: '#123456' }}>
       Inventory Location
      </Typography>
      <Paper sx={{my: 5}}>
        <CreateInventoryLocationComponent/>
      </Paper>
      <Paper sx={{my: 5}}>
        <InventoryLocationList/>
      </Paper>
    </ProcurementContainer>

  )
}

export default InventoryLocationPage